import AuthShell from "@/components/landing/auth/AuthShell";
import {
  extractErrorMessage,
  loginWithApiAndRedirectToDashboard,
} from "@/services/auth/loginWithApi";
import { useState } from "react";
import { Link } from "react-router-dom";

export default function LoginBody() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function onSubmit(event) {
    event.preventDefault();
    setError("");
    setLoading(true);
    try {
      await loginWithApiAndRedirectToDashboard(email, password);
    } catch (err) {
      setError(extractErrorMessage(err));
      setLoading(false);
    }
  }

  return (
    <AuthShell
      title="Welcome back"
      subtitle="Sign in to continue to your dashboard."
      footer={
        <p className="mb-0">
          Don&apos;t have an account? <Link to="/register">Create one</Link>
        </p>
      }>
      <form onSubmit={onSubmit}>
        <div className="single-input">
          <input
            type="email"
            placeholder="Email address"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="single-input">
          <input
            type="password"
            placeholder="Password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {error ? <p className="text-danger small mb-3">{error}</p> : null}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <Link to="/forgot-password">Forgot password?</Link>
          <Link to="/login-2">Use alternate login</Link>
        </div>
        <div className="btn-area mt-0 mb-0">
          <button className="cmn-btn" disabled={loading} type="submit">
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </div>
      </form>
    </AuthShell>
  );
}
